import React, { useEffect } from 'react'
//third party lib
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, Link } from "react-router-dom";
//redux
import { logOut } from '../redux/user';

const LogOut = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()



    useEffect(() => {
        localStorage.setItem("loginToken", "nothing");
        dispatch(logOut())
        navigate("/");
    }, [])
    return (
        <>
        </>
    )
}


export default LogOut